/**
 * Resolve a media URL to an absolute URL.
 * If the URL is already absolute, returns it as-is.
 * If relative (starts with /), prepends the API base origin.
 */
export function getMediaUrl(url: string | undefined | null): string {
  if (!url) return ''
  if (url.startsWith('http://') || url.startsWith('https://')) {
    return url
  }
  const apiUrl = import.meta.env.VITE_API_URL || '/api/v1'
  // Extract origin from VITE_API_URL (e.g. http://localhost:3003/api/v1 -> http://localhost:3003)
  try {
    const parsed = new URL(apiUrl)
    return `${parsed.origin}${url}`
  } catch {
    // fallback for relative api URLs
    return url
  }
}
